export enum CustomEventTypes {
  CropDocImageUserLandedOnHome = ' CropDocImageUserLandedOnHome',
  CropDocImageStartDiagnosisClicked = 'CropDocImageStartDiagnosisClicked ',
  CropDocImageUserTypeSelected = 'CropDocImageUserTypeSelected',
  CropDocImageFarmerAdded = 'CropDocImageFarmerAdded',
  CropDocImageSourceSelected = 'CropDocImageSourceSelected',
  CropDocImageConfirmed = 'CropDocImageConfirmed',
  CropDocImageRejected = 'CropDocImageRejected',
  CropDocImageCropSelectionUserLanded = 'CropDocImageCropSelectionUserLanded',
  CropDocImageCropSelectionCropNotFound = 'CropDocImageCropSelectionCropNotFound',
  CropDocImageDiseaseSelectionUserLanded = 'CropDocImageDiseaseSelectionUserLanded',
  CropDocImageDiseaseSelectionCropEditClick = 'CropDocImageDiseaseSelectionCropEditClick',
  CropDocImageDiseaseSelected = 'CropDocImageDiseaseSelected',
  CropDocImageUserLandedOnDiseaseDetail = 'CropDocImageUserLandedOnDiseaseDetail',
  CropDocImageUserCompletesDiagnosis = 'CropDocImageUserCompletesDiagnosis',
  CropDocImageUserLandedonTreatment = 'CropDocImageUserLandedonTreatment',
  CropDocImageHomeViewAllClicked = 'CropDocImageHomeViewAllClicked',
  CropDocImagePastDiagnosisListingUserLanded = 'CropDocImagePastDiagnosisListingUserLanded',
  CropDocImagePastDiagnosisSelected = 'CropDocImagePastDiagnosisSelected',
  CropDocImagePastDiagnosisFilterClick = 'CropDocImagePastDiagnosisFilterClick',
  CropDocImagePastDiagnosisFilterApplied = 'CropDocImagePastDiagnosisFilterApplied',
  BackButtonClick = 'BackButtonClick',
  CropDocImageViewed = 'CropDocImageViewed',
}
